import { CommonModule } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { InternalCsService } from '@app/shared/services/internal-cs/internal-cs.service';
import { environment } from '@env/environment';
import { CopyToClipboardDirective, IconComponent } from '@ui';

@Component({
  selector: 'sbnb-cs-debug-item',
  standalone: true,
  imports: [CommonModule, CopyToClipboardDirective, IconComponent],
  templateUrl: './cs-debug-item.component.html',
})
export class CsDebugItemComponent {
  readonly label = input<string>();
  readonly value = input<string>();
  readonly borderTop = input<boolean>(false);
  readonly borderBottom = input<boolean>(false);
  readonly link = input<string>();
  readonly linkLabel = input<string>('Link');
  readonly coreNovaLink = input<string>();
  readonly directNovaLink = input<string>();

  #csService = inject(InternalCsService);

  readonly isCS = this.#csService.isCS();
  readonly debugMode$ = this.#csService.debugMode;

  readonly computedLink = computed(() => {
    const coreNova = this.coreNovaLink();
    const directNova = this.directNovaLink();
    const regularLink = this.link();

    if (coreNova) {
      return environment.coreNovaUrl + coreNova;
    } else if (directNova) {
      return environment.directNovaUrl + directNova;
    } else {
      return regularLink;
    }
  });
}
